module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-分享-暗.3e84e.png";